import { EntityModel } from '@/interfaces'
import {
  ALL_CONVERSION_PLATFORM_SUBMISSIONS_QUERY,
  CREATE_CONVERSION_PLATFORM_SUBMISSION_MUTATION,
  DELETE_CONVERSION_PLATFORM_SUBMISSION_MUTATION,
  FORCE_DELETE_CONVERSION_PLATFORM_SUBMISSION_MUTATION,
  SINGLE_CONVERSION_PLATFORM_SUBMISSION_QUERY,
  UPDATE_CONVERSION_PLATFORM_SUBMISSION_MUTATION,
} from './graphql'
import trackingConversionEntity from '@/entities/trackingConversion/entity'

const trackingConversionPlatformSubmissionModel: EntityModel = {
  name: 'conversionPlatformSubmission',
  namePlural: 'conversionPlatformSubmissions',
  uniqueName: 'trackingConversionPlatformSubmission',
  uniqueNamePlural: 'trackingConversionPlatformSubmissions',
  path: 'tracking/conversion_platform_submission',
  baseUrl: '/tracking/conversion_platform_submissions',
  translationPrefix: 'entities:trackingConversionPlatformSubmission.',
  getDisplayName: (values: any) => {
    return ''
  },
  gql: {
    getAll: ALL_CONVERSION_PLATFORM_SUBMISSIONS_QUERY,
    getSingle: SINGLE_CONVERSION_PLATFORM_SUBMISSION_QUERY,
    create: CREATE_CONVERSION_PLATFORM_SUBMISSION_MUTATION,
    update: UPDATE_CONVERSION_PLATFORM_SUBMISSION_MUTATION,
    delete: DELETE_CONVERSION_PLATFORM_SUBMISSION_MUTATION,
    forceDelete: FORCE_DELETE_CONVERSION_PLATFORM_SUBMISSION_MUTATION,
  },
  attributes: {
    conversion: {
      name: 'conversion',
      label: 'entities:trackingConversionPlatformSubmission.attributes.conversion.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return trackingConversionEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    platform: {
      name: 'platform',
      label: 'entities:trackingConversionPlatformSubmission.attributes.platform.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    sentAt: {
      name: 'sentAt',
      label: 'entities:trackingConversionPlatformSubmission.attributes.sentAt.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'datetime',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    status: {
      name: 'status',
      label: 'entities:trackingConversionPlatformSubmission.attributes.status.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    errorMessage: {
      name: 'errorMessage',
      label: 'entities:trackingConversionPlatformSubmission.attributes.errorMessage.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default trackingConversionPlatformSubmissionModel
